"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _ProofpointLogo = _interopRequireDefault(require("../ProofpointLogo"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _excluded = ["dataMetrics"],
  _excluded2 = ["appSwitcher", "children", "companyLogo", "productName", "disableGutters", "variant"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    buttonRoot: {
      '&:hover': {
        backgroundColor: theme.palette.primary.dark
      },
      backgroundColor: theme.palette.primary.dark,
      borderRadius: '0',
      height: 56,
      width: 56
    },
    logoContainer: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      maxHeight: '40px',
      paddingLeft: 16,
      paddingRight: 16
    },
    productName: {
      color: theme.palette.common.white
    },
    root: {
      boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
    }
  });
});
var defaultProps = {
  color: 'primary',
  companyLogo: /*#__PURE__*/_react["default"].createElement(_ProofpointLogo["default"], null),
  dataMetrics: {
    root: 'fuse_appbar',
    toolbar: 'fuse_toolbar'
  },
  disableGutters: true,
  position: 'fixed',
  productName: 'Product Name',
  variant: 'regular'
};

/**
 * AppBar is always fixed at the top of screen. It is used for branding, product name, navigation to other apps, and actions.
 */
var AppBar = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var dataMetrics = _ref.dataMetrics,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var appSwitcher = rest.appSwitcher,
    children = rest.children,
    companyLogo = rest.companyLogo,
    productName = rest.productName,
    disableGutters = rest.disableGutters,
    variant = rest.variant,
    other = (0, _objectWithoutProperties2["default"])(rest, _excluded2);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_AppBar["default"], (0, _extends2["default"])({
    classes: {
      root: classes.root
    },
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, other), /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    "data-metrics": mergedDataMetrics.toolbar,
    variant: variant,
    disableGutters: disableGutters
  }, appSwitcher, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.logoContainer
  }, companyLogo), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.productName,
    variant: "subtitle1",
    align: "center",
    noWrap: true
  }, productName.slice(0, 35)), children));
});
AppBar.defaultProps = defaultProps;
AppBar.displayName = 'AppBar';
AppBar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The App Switcher component.
   */
  appSwitcher: _propTypes["default"].element,
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/app-bar/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['inherit', 'primary', 'secondary', 'default']),
  /**
   * The company logo component to be rendered.
   */
  companyLogo: _propTypes["default"].element,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string,
    toolbar: _propTypes["default"].string
  }),
  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _propTypes["default"].bool,
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: _propTypes["default"].oneOf(['fixed', 'absolute', 'sticky', 'static', 'relative']),
  /**
   * AppBar product name. Must be no longer than 35 characters.
   */
  productName: function productName(props, propName, componentName) {
    if (!/productName/.test(props[propName]) && props[propName].length > 35) {
      return new Error(" `".concat(propName, "` supplied to `").concat(componentName, "` is longer than 35 characters."));
    }
  },
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['regular', 'dense'])
} : {};
var _default = AppBar;
exports["default"] = _default;